import { useMemo } from "react";
import { useHseSummary } from "@dashboard/hooks/useHseSummary";
import { API_STATUS_KEYS, ORDERED_STATUSES } from "./issuesStatusConstants";

export type IssueStatusData = {
    status: string;
    apiKey: string;
    count: number;
    percentage: number;
};

export function useIssuesStatusMetrics() {
    const { data: hseSummary, isLoading, error } = useHseSummary();

    const metrics = useMemo(() => {
        const raw = hseSummary?.metricsIssueByCustomer?.issues_by_status;
        const issuesByStatus = Array.isArray(raw) ? {} : (raw ?? {});
        const total = Object.values(issuesByStatus).reduce((sum, count) => sum + count, 0);

        const active =
            (issuesByStatus[API_STATUS_KEYS.OPEN] || 0) +
            (issuesByStatus[API_STATUS_KEYS.IN_PROGRESS] || 0) +
            (issuesByStatus[API_STATUS_KEYS.IMMEDIATE_ACTION_TAKEN] || 0) +
            (issuesByStatus[API_STATUS_KEYS.COMPLETED] || 0);

        const closedCount = issuesByStatus[API_STATUS_KEYS.CLOSED] || 0;
        const closedPercentage = total > 0 ? (closedCount / total) * 100 : 0;

        const statusListData = ORDERED_STATUSES.map((status) => {
            const count = issuesByStatus[status.apiKey] || 0;
            return {
                apiKey: status.apiKey,
                translationKey: status.translationKey,
                count,
                percentage: total > 0 ? (count / total) * 100 : 0,
            };
        });

        return {
            statusListData,
            total,
            active,
            closedCount,
            closedPercentage,
        };
    }, [hseSummary]);

    return {
        ...metrics,
        isLoading,
        error,
    };
}
